import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import '@/icons'
import iview from 'iview'
import 'view-design/dist/styles/iview.css'
import axios from './tools/interceptors'
import axiosUrl from 'axios'
import '@vant/touch-emulator'
// import 'babel-polyfill'
import 'animate.css'
// import 'font-awesome/css/font-awesome.min.css'
import './assets/scss/reset.scss'
import '@/assets/styles/index.scss' // global css
/* eslint-disable */
import { tap, swipe, panstart, panmove, panend, pan, press, swiperight, swipeleft, swipeup } from '@/directives/touch'
// import { Picker } from 'mint-ui'
// import 'mint-ui/lib/style.css'
// import VueLazyload from 'vue-lazyload'
// import VueLazyComponent from '@xunlei/vue-lazy-component'
// import cascaderMulti from 'cascader-multi'
// import iviewArea from 'iview-area'
// import customForm from './components/custom_form'
import plugin from './plugin'
import editor from './components/editor'
import answer from './components/answer'
import { Cascader, DatePicker, TimePicker, TimeSelect, Table, TableColumn, Radio, Checkbox, Row, Col, Select, Option, Progress, Upload, Slider, Image } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/page/webViewBridge.js'
import {
  Button,
  Rate,
  Field,
  Icon,
  Cascader as VantCascader,
  Toast,
  Popup,
  Picker,
  Popover,
  DropdownMenu,
  DropdownItem,
  DatetimePicker,
  Uploader,
  Dialog,
  Overlay,
  Sticky
} from 'vant'
import 'vant/lib/button/style'
import 'vant/lib/cascader/style'
import 'vant/lib/rate/style'
import 'vant/lib/field/style'
import 'vant/lib/cascader/style'
import 'vant/lib/toast/style'
import 'vant/lib/popup/style'
import 'vant/lib/picker/style'
import 'vant/lib/popover/style'
import 'vant/lib/dropdown-menu/style'
import 'vant/lib/dropdown-item/style'
import 'vant/lib/datetime-picker/style'
import 'vant/lib/uploader/style'
import 'vant/lib/dialog/style'
import 'vant/lib/overlay/style'
import 'vant/lib/sticky/style'
import third from './third'
import i18n from './assets/lang'
import util from './tools/commonUtil'
// import VueClipboard from 'vue-clipboard2'
// import LazyRender from 'vue-lazy-render'
// import VueQriously from 'vue-qriously'
// import Validate from '@/components/editor/validate'
// import preview from 'vue-photo-preview'
// import 'vue-photo-preview/dist/skin.css'
import VueWechatTitle from 'vue-wechat-title'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
// import 'nprogress/nprogress.css'
// import './tools/fundebug'
// import VConsole from 'vconsole'
import './assets/scss/element-variables.scss'
import syncConfig from './tools/syncConfig'

console.log('普通问卷入口')
if (util.getQueryString('env')) {
  window._env_ = util.getQueryString('env')
}

/* 路由异常错误处理，尝试解析一个异步组件时发生错误，重新渲染目标页面 */
router.onError((error) => {
  console.log('router error', error)
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  console.log(targetPath)
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
})

// Vue.use(VueAwesomeSwiper)
Vue.use(VueWechatTitle)
// Vue.use(preview, {
//   tapToClose: true
// })
// Vue.use(VueQriously)
// Vue.use(LazyRender)
// Vue.use(VueLazyComponent)
// Vue.use(VueClipboard)

Vue.use(plugin)
Vue.use(iview)
Vue.use(editor)
Vue.use(answer)
// Vue.use(Tabs)
// Vue.use(TabPane)
Vue.use(Cascader)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(TimeSelect)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(Row)
Vue.use(Col)
Vue.use(Select)
Vue.use(Option)
Vue.use(Progress)
Vue.use(Slider)
Vue.use(Upload)
Vue.use(Image)

Vue.use(Icon)
Vue.use(VantCascader)
Vue.use(Button)
Vue.use(Rate)
Vue.use(Field)
Vue.use(Toast)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Popover)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(DatetimePicker)
Vue.use(Uploader)
Vue.use(Dialog)
Vue.use(Overlay)
Vue.use(Sticky)

Vue.use(third)
// Vue.use(VueLazyload)
// Vue.use(cascaderMulti)
// Vue.use(iviewArea)
// Vue.use(customForm)
// Vue.component(Picker.name, Picker)
Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue()
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$util = util

// let vConsole = new VConsole()
// Vue.use(vConsole)

/* Vue.directive('focus', {
  inserted: function (el, obj) {
    console.log(el)
    el.focus()
  }
}) */

// 获取配置文件地址
let url = ''
if (process.env.NODE_ENV === "development") {
  url = './static/serverConfig_dev.json'
} else {
  url = './static/serverConfig.prod.json'
}

// 同步请求配置文件，并初始化配置
syncConfig(url, function (result) {
  // json字符串转换成为json对象
  // eslint-disable-next-line no-eval
  const data = eval('(' + result + ')')
  for (let key in data) {
    axiosUrl.prototype['$' + key] = data[key]
    Vue.prototype['$' + key] = data[key]
  }
})

// 获取OSS地址
const ossUrl = Vue.prototype.$OSS_URL || process.env.OSS_URL

Vue.filter('filterOssLink', (val) => {
  if (!val) {
    return ''
  }
  if (val.startsWith('file:')) {
    return val
  }
  if (val.includes('static/images')) {
    return val
  }
  if (val.indexOf('http') === -1) {
    return ossUrl + val
  }
  return val
});

Vue.config.errorHandler = (error, vm) => {
  console.log('vue error', error)
};

/* eslint-disable no-new */
const createApp = () => {
  new Vue({
    router,
    store,
    i18n,
    components: { App },
    template: '<App/>'
  }).$mount('#app')
}

// 获取uni app执行环境
window.uni.getEnv(e => {
  window._execEnv_ = e.plus ? 'app' : 'h5'
})

if (window._env_ === 'android' || navigator.userAgent.match(/(uni-app)/i)) {
  document.addEventListener('UniAppJSBridgeReady', function (e) {
    window.uni.getEnv(e => {
      window._execEnv_ = e.plus ? 'app' : 'h5'
    })
    createApp()
  })
} else {
  createApp()
}



// WEBPACK FOOTER //
// ./src/main.js